module.exports = __webpack_public_path__ + "static/media/mobile-05.5bfb6095.png";